import React, { Component } from "react"

export default class CovidTableContainer extends Component {
  render() {
    return (
      <React.Fragment>
        <div className={"rich-text"} dangerouslySetInnerHTML={{ __html: this.props.richTextTop }}></div>
        {this.props.tables && this.props.tables.length > 0
          ? this.props.tables.map((table, index) => {
              return <CovidTable key={index} {...table} />
            })
          : ""}
        <div className={"rich-text"} dangerouslySetInnerHTML={{ __html: this.props.richTextBottom }}></div>
      </React.Fragment>
    )
  }
}

class CovidTable extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="table-title">{this.props.headline}</div>
        {this.props.tableRows && this.props.tableRows.length > 0 ? (
          <table className="covid-qa-table">
            {this.props.tableHeader.tableColumns?.length > 0 ? (
              <thead>
                <CovidTableRow {...this.props.tableHeader} />
              </thead>
            ) : (
              ""
            )}
            {this.props.tableRows && this.props.tableRows.length > 0 ? (
              <tbody>
                {this.props.tableRows.map((row, index) => {
                  return <CovidTableRow key={index} {...row} tableHeader={this.props.tableHeader} />
                })}
              </tbody>
            ) : (
              ""
            )}
            {this.props.sourceText ? (
              <tfoot>
                <tr>
                  <td>{this.props.sourceText}</td>
                </tr>
              </tfoot>
            ) : (
              ""
            )}
          </table>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }
}

class CovidTableRow extends Component {
  render() {
    return this.props.tableColumns && this.props.tableColumns.length > 0 ? (
      <tr>
        {this.props.tableColumns.map((column, index) => {
          if (column.columnColor) {
            const style = { "--color-dot": column.columnColor }
            if (this.props.tableHeader && this.props.tableHeader.tableColumns?.length > 0) {
              return (
                <td style={style} key={index} className={"color-dot"}>
                  <span>{this.props.tableHeader.tableColumns[index].columnText}</span>
                  <span>{column.columnText}</span>
                </td>
              )
            }
            return (
              <td style={style} key={index} className={"color-dot"}>
                <span className={"show"}>{column.columnText}</span>
              </td>
            )
          }
          return <td key={index}>{column.columnText}</td>
        })}
      </tr>
    ) : (
      ""
    )
  }
}
